import { ElMessage } from 'element-plus'
import { useUserStore } from '@/store/modules/user'
import { pharmacyPrintAutoSettingList } from '@/api/manage/printAutoSetting'
import { printDispensingReceipt, printRefundReceipt, printPrescription, printMedicationInstruction, printMedicationLabel, printPatientLabel } from './print'
import { backendDocumentType, getPrintScope, getPrinterBridge, type PrintOutputOptions, type PrintDocument } from './printRules'

const getPharmacyRule = async (document: PrintDocument) => {
  const res = await pharmacyPrintAutoSettingList()
  if (res.code !== 0 || !Array.isArray(res.data)) throw new Error(res.msg || '读取药房自动打印设置失败')
  const item = res.data.find((row: any) => row.documentType === backendDocumentType[document])
  if (!item?.printerName) return undefined
  return {
    deviceName: item.printerName,
    copies: Number(item.printCopies) || 1,
    preview: Boolean(item.previewEnabled),
  }
}

export async function runPharmacyDocument(id: string | number, document: PrintDocument, output?: PrintOutputOptions) {
  const config = { isCharge: true }
  if (output) {
    const user = useUserStore()
    const scope = getPrintScope('pharmacy')
    const token = user.getToken
    output = { ...output, isActive: () => Boolean(scope) && getPrintScope('pharmacy') === scope && user.getToken === token }
  }
  switch (document) {
    // allowLinkedInstructions: true 由 printDispensingReceipt 内部按打印设置决定是否接着打印用药说明。
    case 'dispensing_receipt': return printDispensingReceipt(id, { allowLinkedInstructions: true }, output)
    case 'refund_receipt': return printRefundReceipt(id, config, output, { includeDrugReturnDetails: true })
    case 'prescription': return printPrescription(id, config, output)
    case 'instruction': return printMedicationInstruction(id, false, output)
    case 'medication_label': return printMedicationLabel(id, config, output)
    case 'patient_label': return printPatientLabel(id, config, output)
  }
}

export async function printPharmacyDocument(id: string | number, document: PrintDocument) {
  try {
    return await runPharmacyDocument(id, document, await getPharmacyRule(document))
  } catch (error) {
    ElMessage.error(error instanceof Error ? error.message : '打印失败')
  }
}
// 该单据已配置为「有新发药单时自动打印」时，本机发药回调不再重复打印一次。
export async function isPharmacyMessagePrintEnabled(document: PrintDocument) {
  if (!getPrinterBridge()) return false
  const res = await pharmacyPrintAutoSettingList()
  if (res.code !== 0 || !Array.isArray(res.data)) return false
  return Boolean(res.data.some((row: any) => row.documentType === backendDocumentType[document] && row.autoPrintOnChargeCompleted && row.printerName))
}
